import { SecondaryButton, TertiaryButton } from "components/Buttons";
import ReactMarkdown from "react-markdown";
import { useHistory } from "react-router-dom";
import "./styles.sass";
export const MarkdownComponent = ({ source }) => {
  const history = useHistory();
  return (
    <div className="help__screen">
      <div className="help__screen__header">
        <TertiaryButton modifiers={["small"]} onClick={() => history.goBack()}>
          Regresar
        </TertiaryButton>
      </div>
      <ReactMarkdown children={source} />
    </div>
  );
};
